import { CompiledApiOperations, compileApiOperations } from '../../utils/redux-rest-api/operationHelper'
import * as rawApiOperations from './apiOperations'

export * from './reducer'
export const apiOperations: CompiledApiOperations<typeof rawApiOperations> = compileApiOperations(rawApiOperations)
